<template>
  <div>
    <input
      type="text"
      class="form-control"
      id="__ncm_input_cep"
      :placeholder="placeholder"
      :disabled="disabled"
      @blur.prevent="onblur()"
      @keydown.enter="onEnter"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      :value="currentValue"
    />
    <span v-bind:class="icon"></span>
  </div>
</template>
<script type="text/javascript">
export default {
  props: ['value', 'placeholder', 'icon', 'disabled'],
  data() {
    return {
      currentValue: ''
    }
  },
  mounted() {},
  methods: {
    onblur() {
      if (this.currentValue && this.currentValue.length === 9) {
        this.$emit('input-blur')
        this.$emit('on-blur')
      }
    },

    mask(value) {
      this.currentValue = value.replace(/[^0-9]+/g, '')
      if (this.currentValue.length > 5) {
        this.currentValue = `${this.currentValue.substring(0, 5)}-${this.currentValue.substring(5)}`
      }
      this.$emit('input', this.valueUnmasked)
    },

    onKeyUp(event) {
      this.mask(event.target.value)
    },

    onKeyDown(e) {
      if (e.target.value.length === 9) {
        if (e.keyCode !== 8 && e.keyCode !== 9) {
          e.preventDefault()
        }
      }
    },

    onEnter() {
      this.$emit('on-enter')
    }
  },
  computed: {
    valueUnmasked() {
      return this.currentValue.replace(/[^0-9]+/g, '')
    }
  },
  watch: {
    value(vl) {
      if (vl) {
        this.currentValue = vl
        this.mask(vl)
      }
    }
  }
}
</script>
